import { render, staticRenderFns } from "./MaterialsViewDialog.vue?vue&type=template&id=04894fe4&scoped=true"
import script from "./MaterialsViewDialog.vue?vue&type=script&lang=js"
export * from "./MaterialsViewDialog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsViewDialog.vue?vue&type=style&index=0&id=04894fe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04894fe4",
  null
  
)

export default component.exports